import styled from '@emotion/styled';

export const UsersAccessSettingsContainer = styled.div`
  margin-top: 32px;
`;

export const Spacing = styled.div`
  margin-top: 48px;
`;
